import * as _ from "lodash-es";
import moment from "moment-timezone";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";
import IOrder from "../../../../models/IOrder";
import IOrder_Item from "../../../../models/IOrder_Item";
import ISupplierModel from "../../../../models/ISupplierModel";
import IInvoiceViewOptions from "../../../../models/IInvoiceViewOptions";
import AddressDisplay from "../../../shared/AddressDisplay/AddressDisplay";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwTranslate from "../../../shared/OwTranslate/OwTranslate";
import PackingListItemRow from "../../../shipments/ShipmentPackingList/PackingListItemRow/PackingListItemRow";
import UIService from "../../../../services/UIService";
import { WhiteLabelLogo } from "../../../shared/WhiteLabelLogo/WhiteLabelLogo";
import CatalogItemService from "../../../../services/CatalogItemService";
import { DocLogo } from "../../../shared/DocLogo/DocLogo";
import { CatalogItemDescription } from "../../../shared/CatalogItemDescription/CatalogItemDescription";
import { OwBarcode } from "../../../shared/OwBarcode/OwBarcode";
import HelperService from "../../../../services/HelperService";
import "./OrderCreateInvoiceView.scss";

type Props = {
    order?: IOrder;
    viewOptions: IInvoiceViewOptions;
    supplierModel: ISupplierModel;
};

type State = {};

class OrderCreateInvoiceView extends Component<Props, State> {
    render() {
        if (!this.props.order) {
            return null;
        }

        const vendorModel = this.props.order.Vendor;

        const supplierShipTo = this.props.supplierModel!.Ship_To;

        const shipmentGroupShipTo = !_.isNil(this.props.order.Ship_To) ? this.props.order.Ship_To : vendorModel?.Ship_To;
        const shipmentGroupBillTo = vendorModel?.Bill_To;

        const OrderItemsParsed = _.map(this.props.order.Order_Items, (item) => {
            item.item_no = Number(item.item_no);
            return item;
        });

        const OrderItems = _.sortBy(OrderItemsParsed, ["item_no", "asc"]);
        // const OrderItems = _.sortBy(this.props.order.Order_Items, ["item_no", "asc"]);
        const orderModel = this.props.order;

        const orderDate = moment(orderModel.confirmed_date || orderModel.submit_date || orderModel.created_at).format("MM/DD/YYYY");

        const orderNumsArr: string[] = [];
        const poNumsArr: string[] = [];
        const notes = orderModel.note || "";

        orderNumsArr.push(orderModel.name || "");

        if (orderModel.po_no) {
            poNumsArr.push(orderModel.po_no);
        }

        const orderNums = (
            <Link className={"no-text-style"} to={`/orders/${orderModel.guid}/entry`}>
                {orderModel.name}
            </Link>
        );
        const poNums = poNumsArr.join(",");

        const orderItemRows = _.map(OrderItems, (orderItem: IOrder_Item, index: number) => {
            const calculatedTotal = Number(orderItem.net_price) * Number(orderItem.qty);

            const rowTotal = (
                <NumericFormat
                    value={calculatedTotal}
                    decimalScale={this.props.supplierModel.pricing_precision || 2}
                    displayType={"text"}
                    fixedDecimalScale={true}
                    prefix={"$"}
                />
            );

            const pricePerUnit = (
                <NumericFormat
                    value={orderItem.net_price}
                    decimalScale={this.props.supplierModel.pricing_precision || 2}
                    displayType={"text"}
                    fixedDecimalScale={true}
                    prefix={"$"}
                />
            );

            return (
                <tr>
                    <td>{UIService.roundNumber(orderItem.item_no)}</td>
                    <td>{orderItem.Catalog_Item?.name}</td>
                    {this.props.viewOptions.showSku ? (
                        <td>
                            <div>{orderItem.Catalog_Item?.sku}</div>
                            {this.props.viewOptions.showSkuBarcode && orderItem.Catalog_Item?.sku?.length ? (
                                <div>
                                    <OwBarcode format={"CODE128"} value={orderItem.Catalog_Item.sku} height={50} />
                                </div>
                            ) : null}
                        </td>
                    ) : null}
                    {this.props.viewOptions.showDescription ? (
                        <td>
                            {orderItem.description || orderItem.Catalog_Item ? (
                                <CatalogItemDescription
                                    catalogItem={orderItem.Catalog_Item!}
                                    priceGroup={this.props.order?.Price_Group}
                                    orderItem={orderItem}
                                />
                            ) : (
                                ""
                            )}
                        </td>
                    ) : null}
                    {this.props.viewOptions.showUom ? <td>{orderItem.Catalog_Item?.Unit_Of_Measurement?.abbreviation}</td> : null}
                    {this.props.viewOptions.showOrderQty ? (
                        <td className={"text-end"}>
                            <NumericFormat
                                value={orderItem.qty}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={this.props.supplierModel.qty_precision || 0}
                                fixedDecimalScale={true}
                            />
                        </td>
                    ) : null}
                    {this.props.viewOptions.showUnitPrice ? <td className={"text-end"}>{pricePerUnit}</td> : null}
                    <td className={"text-end"}>{rowTotal}</td>
                </tr>
            );
        });

        let tableClass = "table-dark";

        if (UIService.isMainViewLight()) {
            tableClass = "";
        }

        let showBillToVendorName = false;

        if (shipmentGroupBillTo?.name !== vendorModel?.name) {
            showBillToVendorName = true;
        }

        return (
            <div className="OrderCreateInvoiceView">
                <div className={"row top-row"}>
                    <div className={"col col-md-4 black-box"}>
                        {this.props.supplierModel.Doc_Logo ? (
                            <DocLogo maxWidth={"20rem"} height={"auto"} />
                        ) : (
                            <WhiteLabelLogo height={"auto"} maxWidth={"20rem"} maxHeight={"15rem"} />
                        )}
                        {!this.props.viewOptions.hideBusinessName ? (
                            <>
                                <OwTitle disableTranslation={true} title={this.props.supplierModel.name} tag={"h5"} className={"mb-0"} />
                                <div>{supplierShipTo.address_line_one}</div>
                                <div>{supplierShipTo.address_line_two}</div>
                                <div>
                                    {supplierShipTo.city}, {supplierShipTo.state} {supplierShipTo.postal_code}
                                </div>
                            </>
                        ) : null}
                        <div className={"mt-2"}>
                            <div className={this.props.viewOptions.showPhone && this.props.supplierModel.phone ? "" : "d-none"}>
                                <b>
                                    <OwTranslate defaultMessage={"phone"} id={"phone"} />:
                                </b>{" "}
                                {this.props.supplierModel.phone}
                            </div>
                            <div className={this.props.viewOptions.showEmail && this.props.supplierModel.email ? "" : "d-none"}>
                                <b>
                                    <OwTranslate defaultMessage={"email"} id={"email"} />:
                                </b>{" "}
                                {this.props.supplierModel.email}
                            </div>
                        </div>
                    </div>
                    <div className={"text-end d-flex d-md-none flex-column col"}>
                        <h3>
                            <OwTranslate defaultMessage={"Invoice"} id={"invoice"} />
                        </h3>
                        <p>Date: {moment().format("MM/DD/YYYY")}</p>
                    </div>
                    <div className={"text-end d-none d-md-flex flex-column col-md-8"}>
                        <h3>
                            <OwTranslate defaultMessage={"Invoice"} id={"invoice"} />
                        </h3>
                        <p>Date: {moment().format("MM/DD/YYYY")}</p>
                    </div>
                </div>

                <div className={"row bill-to-ship-to-row mt-5"}>
                    {this.props.viewOptions.showBillTo ? (
                        <div className={"col-4 col-md-4 black-box"}>
                            <OwTitle leftIconName={"fal fa-building"} className={"underline"} title={"bill_to"} tag={"h5"} />
                            {shipmentGroupBillTo?.company_name ? null : showBillToVendorName ? (
                                <OwTitle tag={"h5"} disableTranslation={true} title={vendorModel?.name || ""} className={"mb-0"} />
                            ) : null}
                            <AddressDisplay address={shipmentGroupBillTo} showName={true} showCompanyName={true} />
                        </div>
                    ) : null}

                    <div className={"col-4 col-md-4 black-box border-left-0"}>
                        <OwTitle leftIconName={"fal fa-truck"} title={"ship_to"} tag={"h5"} className={"underline"} />
                        <AddressDisplay address={shipmentGroupShipTo} showName={true} showCompanyName={true} />
                    </div>
                </div>

                <div className={"table-responsive mt-2"}>
                    <table className={"table table-bordered " + tableClass}>
                        <tbody>
                            <tr>
                                <th>
                                    <OwLabel title={"order_date"} className={"mb-0"} />
                                </th>
                                <th>
                                    <OwLabel title={"order_no"} className={"mb-0"} />
                                </th>
                                <th>
                                    <OwLabel title={"po_no"} className={"mb-0"} />
                                </th>
                                <th>
                                    <OwLabel title={"notes"} className={"mb-0"} />
                                </th>
                            </tr>
                            <tr>
                                <td>{orderDate}</td>
                                <td>{orderNums}</td>
                                <td>{poNums}</td>
                                <td>{notes}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={"table-responsive"}>
                    <table className={"table table-bordered " + tableClass}>
                        <tbody>
                            <tr>
                                <th>
                                    <OwLabel title={"no"} className={"mb-0"} />
                                </th>
                                <th>
                                    <OwLabel title={"item"} className={"mb-0"} />
                                </th>
                                {this.props.viewOptions.showSku ? (
                                    <th>
                                        <OwLabel title={"sku"} className={"mb-0"} />
                                    </th>
                                ) : null}
                                {this.props.viewOptions.showDescription ? (
                                    <th>
                                        <OwLabel title={"description"} className={"mb-0"} />
                                    </th>
                                ) : null}
                                {this.props.viewOptions.showUom ? (
                                    <th>
                                        <OwLabel title={"uom"} className={"mb-0"} />
                                    </th>
                                ) : null}
                                {this.props.viewOptions.showOrderQty ? (
                                    <th className={"text-end"}>
                                        <OwLabel title={"order_qty"} className={"mb-0"} />
                                    </th>
                                ) : null}
                                {this.props.viewOptions.showUnitPrice ? (
                                    <th className={"text-end"}>
                                        <OwLabel title={"unit_price"} className={"mb-0"} />
                                    </th>
                                ) : null}
                                <th className={"text-end"}>
                                    <OwLabel title={"total"} className={"mb-0"} />
                                </th>
                            </tr>
                            {orderItemRows}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default OrderCreateInvoiceView;
